/**
 * Created by Gaplo917 on 10/7/2017.
 */
import Scene from "./objects/Scene";
import R from "./config/R"
import Button from "./objects/Button";
import FullScreenBg from "./objects/FullScreenBg";
import * as Events from "./Events"
import SoundManager from "./SoundManager";
import MainGame from "./MainGame"
import Image from "./objects/Image";
import {BannerText} from "./characters/common/BannerText"

export default class Scene2 extends Scene {
  constructor(resources){
    super()
    SoundManager.instance.stopBackground()

    const bg1 = new FullScreenBg(resources[R.images.selectStageBg.name].texture)
    const playBtn = new Button(1800, 1340, resources[R.images.selectionBtnPlay.name].texture)
    const hearBtn = new Button(1620, 1340, resources[R.images.selectionBtnRE.name].texture)

    // Add the bunny to the scene we are building.
    this.addChild(bg1)
    this.addChild(playBtn)
    this.addChild(hearBtn)

    this.schedulePlayVO = setTimeout(() => {
      playBtn.addOnClickListener(() => {
        SoundManager.instance.stopEffect(R.sounds.pth_6bs2_p52_ga_02)
        this.nextScene(R.scenes.LEVEL_3, {passedLevel : 0})
      })

      hearBtn.addOnClickListener(() => {
        SoundManager.instance.stopEffect(R.sounds.pth_6bs2_p52_ga_02)
        SoundManager.instance.playEffect(R.sounds.pth_6bs2_p52_ga_02)
      })
      SoundManager.instance.playEffect(R.sounds.pth_6bs2_p52_ga_02)
    }, 0)
  }

  destroy(){
    clearTimeout(this.schedulePlayVO)
  }

  nextScene(sceneId, data){
    console.log("go to next scene 3 with data:", data)
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : sceneId, data: data})
  }
}



// WEBPACK FOOTER //
// ./src/game/Scene2.js